import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import { useSearchParams } from "next/navigation";
import TunnelStepsLayout from "@components/views/TunnelSteps/TunnelStepsLayout";
import { Button, Image, Link } from "@components/core";

function ReadyToSignUp() {
  const t = useTranslations("tunnel_steps");

  const router = useRouter();
  const searchParams = useSearchParams();

  const handleSubmit = () => {
    const queryStringified = searchParams.toString();
    const query = queryStringified ? `?${queryStringified}` : "";
    router.push(`/je-commence/prenom${query}`);
  };

  return (
    <TunnelStepsLayout
      currentSectionNumber={0}
      currentStepNumber={0}
    >
      <section className="container ready-to-container">
        <Image
          src="boxLightNeon"
          alt="box"
          width={140}
          height={140}
          className="mb-5"
        />
        <h4 className="mb-3">{t("ready_to_signup.lets_go")}</h4>
        <p className="mb-5">
          {t("ready_to_signup.setup_account_and_unlock_your_unlimited_dressing")}
        </p>
        <Button onClick={handleSubmit}>{t("ready_to_signup.next_button_label")}</Button>

        <div className="d-flex gap-2 mt-4">
          <p className="font-size-sm text-gray">{t("ready_to_signup.already_have_an_account")}</p>
          <Link
            href="/sign-in"
            className="font-size-sm"
          >
            {t("ready_to_signup.login")}
          </Link>
        </div>
      </section>
    </TunnelStepsLayout>
  );
}

export default ReadyToSignUp;
